import React from "react"

import { images } from "../../config/image-definitions"
import BackgroundImage from "./BackgroundImage"
import ExpandableIcon from "./ExpandableIcon"
import SideCheckBox from "./SideCheckBox"
import SideRemoveButton from "./SideRemoveButton"

const UserListItem = ({
    id,
    activeId,
    photo_url,
    full_name,
    labels,
    labelColor,
    primary_position,
    primary_organisation,
    onClick,
    onRemove,
    isExpandable,
    isExpanded,
    onChecked,
    optionalClass,
    isAdded,
    dataCy
}) => {
    return (
        <div
            className={`list-group-item force-chrome-rerender align-items-start ${id ===
            activeId
                ? "active"
                : ""} ${optionalClass || ""}`}
            onClick={
                !isExpanded && (onClick || onChecked) ? (
                    (onClick || onChecked)(id)
                ) : (
                    () => null
                )
            }
            data-cy={dataCy}
        >
            <BackgroundImage
                classList={["list-group-item-thumb thumb-rounded"]}
                imageUrl={photo_url}
                defaultImageUrl={images.peoplePlaceholder}
            />
            <div className="list-group-item-content">
                <h4 className="text-shorten-single-line">{full_name}</h4>
                <p>{primary_position}</p>
                <p className="primary-organisation">{primary_organisation}</p>
                {labels &&
                !isExpanded && (
                    <div className="tags" style={{ marginTop: "10px" }}>
                        {labels.map(label => (
                            <div
                                className={`tag-item ${labelColor || "grey"}`}
                                key={label}
                            >
                                {label}
                            </div>
                        ))}
                    </div>
                )}
                {onRemove && <SideRemoveButton onClick={onRemove} />}
                {onChecked && <SideCheckBox isAdded={isAdded} />}
            </div>
            {isExpandable && (
                <ExpandableIcon
                    isExpanded={isExpanded}
                    rotation={-90}
                    onClick={(onClick || onChecked)(id)}
                />
            )}
        </div>
    )
}

export default UserListItem
